import { Component, inject } from '@angular/core';
import { CapturumButtonModule } from '@capturum/ui/button';
import { CapturumInputModule } from '@capturum/ui/input';
import { CapturumInputSwitchModule } from '@capturum/ui/input-switch';
import { CapturumPasswordModule } from '@capturum/ui/password';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LgLoginService } from '@shared/modules/layout/services/lg-login.service';
import { LoginComponent } from '@capturum/login';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutes } from '@core/enums/routes.enum';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-sso-all-stars',
    imports: [
        CapturumButtonModule,
        CapturumInputModule,
        CapturumInputSwitchModule,
        CapturumPasswordModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        RouterLink,
    ],
    templateUrl: './sso-all-stars.component.html'
})
export class SsoAllStarsComponent extends LoginComponent {
  private readonly lgLoginService = inject(LgLoginService);

  protected readonly AppRoutes = AppRoutes;

  public loginSSO(): void {
    if (this.form.controls.email.invalid) return;
    this.lgLoginService.ssoLogin({ email: this.form.getRawValue().email! }).subscribe({
      next: ({ redirect_url }) => {
        this.redirect(redirect_url);
      },
    });
  }

  protected redirect(url: string): void {
    window.location.href = url;
  }
}
